const axios = require('axios');
import constants from '../constants';
import mixin from '../vue/mixin';

document.addEventListener('DOMContentLoaded', async () => {
    const $registrationForm = document.querySelector('.registration-form');
    const urlParams = new URLSearchParams(window.location.search);
    const artnr = urlParams.get('artnr');

    if ($registrationForm && artnr) {
        const $artcodeField = $registrationForm.querySelector('.artcode.hidden');

        if ($artcodeField) {
            const $artcodeInput = $artcodeField.querySelector('input');
            $artcodeInput.value = artnr;
        }

        // Insert event metadata through JS because the form is rendered through Umbraco Forms.
        const $formCaption = $registrationForm.querySelector('.umbraco-forms-caption');

        if ($formCaption) {
            const path = constants.paths.base + constants.paths.events;
            const queryModel = {
                Limit: 1,
                FilterItems: [{ Key: constants.filterAliases.webshopArtcode, Values: [artnr], Operator: constants.operators.in }],
            };

            let response = null;
            try {
                response = await axios.post(path, queryModel);
            } catch (error) {
                console.log(error);
            }

            if (response && response.data && response.data.items && response.data.items.length) {
                const event = response.data.items[0];

                const $metadataField = document.createElement('fieldset');
                $metadataField.classList.add('field', 'mb-5');

                const dateLabel = document.body.dataset.datelabel || 'Date';
                const feeLabel = document.body.dataset.feelabel || 'Fee';
                const venueLabel = document.body.dataset.venuelabel || 'Venue';
                const addressLabel = document.body.dataset.addresslabel || 'Address';

                if (event.name) {
                    const $title = document.createElement('h3');
                    $title.classList.add('title', 'is-4');
                    $title.textContent = event.name;
                    $metadataField.appendChild($title);
                }

                const $dateField = document.createElement('div');
                $dateField.classList.add('field', 'is-flex', 'is-flex-wrap-wrap', 'is-align-items-center', 'mb-0');

                const $dateLabel = document.createElement('label');
                $dateLabel.textContent = `${dateLabel}:`;
                $dateLabel.classList.add('label', 'is-size-lead', 'mb-0', 'mr-2');
                $dateField.appendChild($dateLabel);

                const $dateControl = document.createElement('p');
                $dateControl.classList.add('control', 'is-flex-grow-1');
                const $dateInput = document.createElement('input');
                $dateInput.type = 'text';
                $dateInput.value = mixin.methods.toDatesStr(event.startDate, event.endDate);
                $dateInput.readOnly = true;
                $dateInput.classList.add('input', 'is-static', 'py-0');
                $dateControl.appendChild($dateInput);
                $dateField.appendChild($dateControl);

                $metadataField.appendChild($dateField);

                if (event.fee) {
                    const $feeField = document.createElement('div');
                    $feeField.classList.add('field', 'is-flex', 'is-flex-wrap-wrap', 'is-align-items-center', 'mb-0');

                    const $feeLabel = document.createElement('label');
                    $feeLabel.textContent = `${feeLabel}:`;
                    $feeLabel.classList.add('label', 'is-size-lead', 'mb-0', 'mr-2');
                    $feeField.appendChild($feeLabel);

                    const $feeControl = document.createElement('p');
                    $feeControl.classList.add('control', 'is-flex-grow-1');
                    const $feeInput = document.createElement('input');
                    $feeInput.type = 'text';
                    $feeInput.value = event.fee;
                    $feeInput.readOnly = true;
                    $feeInput.classList.add('input', 'is-static', 'py-0');
                    $feeControl.appendChild($feeInput);
                    $feeField.appendChild($feeControl);

                    $metadataField.appendChild($feeField);
                }

                if (event.venue) {
                    const $venueField = document.createElement('div');
                    $venueField.classList.add('field', 'is-flex', 'is-flex-wrap-wrap', 'is-align-items-center', 'mb-0');

                    const $venueLabel = document.createElement('label');
                    $venueLabel.textContent = `${venueLabel}:`;
                    $venueLabel.classList.add('label', 'is-size-lead', 'mb-0', 'mr-2');
                    $venueField.appendChild($venueLabel);

                    const $venueControl = document.createElement('p');
                    $venueControl.classList.add('control', 'is-flex-grow-1');
                    const $venueInput = document.createElement('input');
                    $venueInput.type = 'text';
                    $venueInput.value = event.venue;
                    $venueInput.readOnly = true;
                    $venueInput.classList.add('input', 'is-static', 'py-0');
                    $venueControl.appendChild($venueInput);
                    $venueField.appendChild($venueControl);

                    $metadataField.appendChild($venueField);
                }

                const parsedAddress = JSON.parse(event.address);
                if (parsedAddress && parsedAddress.markup) {
                    const $addressField = document.createElement('div');
                    $addressField.classList.add('field', 'is-flex', 'is-flex-wrap-wrap', 'my-3');

                    const $addressLabel = document.createElement('label');
                    $addressLabel.textContent = `${addressLabel}:`;
                    $addressLabel.classList.add('label', 'is-size-lead', 'mb-0', 'mr-2');
                    $addressField.appendChild($addressLabel);

                    const $addressControl = document.createElement('p');
                    $addressControl.classList.add('control', 'is-flex-grow-1', 'is-size-lead');
                    const $addressContent = document.createElement('div');
                    $addressContent.innerHTML = parsedAddress.markup;
                    $addressContent.classList.add('content');
                    $addressControl.appendChild($addressContent);
                    $addressField.appendChild($addressControl);

                    $metadataField.appendChild($addressField);
                }

                $formCaption.insertAdjacentElement('afterend', $metadataField);
            }
        }
    }
});
